const WISHLIST_STORAGE_KEY = 'true_rest:wishlist';
const WISHLIST_UPDATED_EVENT = 'wishlist:updated';

class Wishlist {
  static get() {
    try {
      const raw = localStorage.getItem(WISHLIST_STORAGE_KEY);
      const handles = raw ? JSON.parse(raw) : [];
      return Array.isArray(handles) ? handles : [];
    } catch (error) {
      return [];
    }
  }

  static has(handle) {
    return Wishlist.get().includes(handle);
  }

  static toggle(handle) {
    const handles = Wishlist.get();
    const index = handles.indexOf(handle);
    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }
    localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(handles));
    document.dispatchEvent(
      new CustomEvent(WISHLIST_UPDATED_EVENT, { detail: { handles, handle, saved: index === -1 } })
    );
    return index === -1;
  }
}

class WishlistToggle extends HTMLButtonElement {
  connectedCallback() {
    this.handle = this.dataset.productHandle;
    this.syncState();
    this.addEventListener('click', this.onClick.bind(this));
    document.addEventListener(WISHLIST_UPDATED_EVENT, this.onWishlistUpdated.bind(this));
  }

  onClick() {
    Wishlist.toggle(this.handle);
  }

  onWishlistUpdated(event) {
    if (event.detail.handle === this.handle) this.syncState();
  }

  syncState() {
    const saved = Wishlist.has(this.handle);
    this.setAttribute('aria-pressed', String(saved));
    this.classList.toggle('wishlist-toggle--saved', saved);
  }
}

class WishlistCount extends HTMLElement {
  connectedCallback() {
    this.update();
    document.addEventListener(WISHLIST_UPDATED_EVENT, this.update.bind(this));
  }

  update() {
    const count = Wishlist.get().length;
    this.textContent = count > 0 ? count : '';
    this.hidden = count === 0;
  }
}

if (!customElements.get('wishlist-toggle')) {
  customElements.define('wishlist-toggle', WishlistToggle, { extends: 'button' });
}
if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', WishlistCount);
}

window.TrueRestWishlist = Wishlist;
